import {
  DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  PictureDesktopNames,
  PictureTransformations,
} from 'common/components';
import { INTERIOR_DOORS_LANDING_NAME } from '../../interior-doors-constants';

export type InteriorDoorsGalleryStructure = {
  alt: string;
  name: string;
  src: string;
  srcSmall: string;
  transformations?: PictureTransformations;
};

const GIF_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 578,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 458,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 458,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 458,
    height: 380,
    objectFit: 'fill',
    dpr: '2.0',
  },
};

export const INTERIOR_DOORS_GALLERY: InteriorDoorsGalleryStructure[] = Array(13)
  .fill(null)
  .map((_, index: number) => {
    const imageName = index + 1;
    const fileExtension = index === 2 || index === 11 ? `.gif/${imageName}.gif` : `.jpg/${imageName}.jpg`;
    const transformation =
      index === 2 || index === 11 ? GIF_TRANSFORMATIONS : DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS;
    const baseInfo = {
      alt: '',
      name: `${imageName}.${index === 2 || index === 11 ? 'gif' : 'jpg'}`,
      src: `${INTERIOR_DOORS_LANDING_NAME}/gallery-popup/${imageName}.jpg/image-image.jpg`,
      srcSmall: `${INTERIOR_DOORS_LANDING_NAME}/gallery/${imageName}${fileExtension}`,
      transformations: transformation,
    };

    if (index % 5 === 4 || index === 10) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  });
